import { LawFieldEnum } from '@/types/generated'

export const lawFieldsDE: Record<string, string> = {
  [LawFieldEnum.ALLGEMEIN]: 'Allgemein',
  [LawFieldEnum.ARBEITSRECHT]: 'Arbeitsrecht',
  [LawFieldEnum.ASYLRECHT]: 'Asylrecht',
  [LawFieldEnum.AUSLÄNDERRECHT]: 'Ausländerrecht',
  [LawFieldEnum.BANKRECHT]: 'Bankrecht',
  [LawFieldEnum.BAURECHT]: 'Baurecht',
  [LawFieldEnum.BEAMTENRECHT]: 'Beamtenrecht',
  [LawFieldEnum.BEWERTUNGEN_LÖSCHEN]: 'Bewertungen löschen',
  [LawFieldEnum.CASINO]: 'Casino',
  [LawFieldEnum.COACHING]: 'Coaching',
  [LawFieldEnum.COMPLIANCE]: 'Compliance',
  [LawFieldEnum.CORONA_ÜBERBRÜCKUNGSHILFE]: 'Corona Überbrückungshilfe',
  [LawFieldEnum.DATENLECK]: 'Datenleck',
  [LawFieldEnum.ERBRECHT]: 'Erbrecht',
  [LawFieldEnum.FAMILIENRECHT]: 'Familienrecht',
  [LawFieldEnum.GESELLSCHAFTSRECHT]: 'Gesellschaftsrecht',
  [LawFieldEnum.GEWERBLICHER_RECHTSSCHUTZ_URHEBERRECHT]: 'Gewerblicher Rechtsschutz/Urheberrecht',
  [LawFieldEnum.HOCHSCHULRECHT]: 'Hochschulrecht',
  [LawFieldEnum.IMMOBILIENRECHT]: 'Immobilienrecht',
  [LawFieldEnum.INKASSO]: 'Inkasso',
  [LawFieldEnum.IT_RECHT]: 'IT Recht',
  [LawFieldEnum.INSOLVENZBERATUNG]: 'Insolvenzberatung',
  [LawFieldEnum.MARKENRECHT]: 'Markenrecht',
  [LawFieldEnum.MEDIEN_UND_PRESSERECHT]: 'Medien-und Presserecht',
  [LawFieldEnum.MEDIZINRECHT]: 'Medizinrecht',
  [LawFieldEnum.MIETRECHT]: 'Mietrecht',
  [LawFieldEnum.MIGRATIONSRECHT]: 'Migrationsrecht',
  [LawFieldEnum.MUSIKRECHT]: 'Musikrecht',
  [LawFieldEnum.NOTARIAT]: 'Notariat',
  [LawFieldEnum.PERSONENSCHÄDEN]: 'Personenschäden',
  [LawFieldEnum.SCHUFA]: 'Schufa',
  [LawFieldEnum.SCHULRECHT]: 'Schulrecht',
  [LawFieldEnum.SOCIAL_MEDIA_RECHT]: 'Social Media Recht',
  [LawFieldEnum.SOZIALRECHT]: 'Sozialrecht',
  [LawFieldEnum.STEUERBERATUNG]: 'Steuerberatung',
  [LawFieldEnum.STEUERRECHT]: 'Steuerrecht',
  [LawFieldEnum.STRAFRECHT]: 'Strafrecht',
  [LawFieldEnum.TESLA_WIDERRUF]: 'Tesla_Widerruf',
  [LawFieldEnum.TIERRECHT]: 'Tierrecht',
  [LawFieldEnum.VERKEHRSRECHT]: 'Verkehrsrecht',
  [LawFieldEnum.VERSICHERUNGSRECHT]: 'Versicherungsrecht',
  [LawFieldEnum.VERWALTUNGSRECHT]: 'Verwaltungsrecht',
  [LawFieldEnum.WEGRECHT]: 'Wegrecht',
  [LawFieldEnum.ZIVILRECHT]: 'Zivilrecht'
}

export const lawFieldsEN: Record<string, string> = {
  [LawFieldEnum.ALLGEMEIN]: 'General',
  [LawFieldEnum.ARBEITSRECHT]: 'Labour Law',
  [LawFieldEnum.ASYLRECHT]: 'Asylum Law',
  [LawFieldEnum.AUSLÄNDERRECHT]: 'Immigration Law',
  [LawFieldEnum.BANKRECHT]: 'Banking Law',
  [LawFieldEnum.BAURECHT]: 'Construction Law',
  [LawFieldEnum.BEAMTENRECHT]: 'Civil Service Law',
  [LawFieldEnum.BEWERTUNGEN_LÖSCHEN]: 'Review Deletion',
  [LawFieldEnum.CASINO]: 'Casino',
  [LawFieldEnum.COACHING]: 'Coaching',
  [LawFieldEnum.COMPLIANCE]: 'Compliance',
  [LawFieldEnum.CORONA_ÜBERBRÜCKUNGSHILFE]: 'Corona Bridge Aid',
  [LawFieldEnum.DATENLECK]: 'Data Breach',
  [LawFieldEnum.ERBRECHT]: 'Inheritance Law',
  [LawFieldEnum.FAMILIENRECHT]: 'Family Law',
  [LawFieldEnum.GESELLSCHAFTSRECHT]: 'Corporate Law',
  [LawFieldEnum.GEWERBLICHER_RECHTSSCHUTZ_URHEBERRECHT]: 'Intellectual Property/Copyright Law',
  [LawFieldEnum.HOCHSCHULRECHT]: 'Higher Education Law',
  [LawFieldEnum.IMMOBILIENRECHT]: 'Real Estate Law',
  [LawFieldEnum.INKASSO]: 'Debt Collection',
  [LawFieldEnum.IT_RECHT]: 'IT Law',
  [LawFieldEnum.INSOLVENZBERATUNG]: 'Insolvency Consulting',
  [LawFieldEnum.MARKENRECHT]: 'Trademark Law',
  [LawFieldEnum.MEDIEN_UND_PRESSERECHT]: 'Media and Press Law',
  [LawFieldEnum.MEDIZINRECHT]: 'Medical Law',
  [LawFieldEnum.MIETRECHT]: 'Tenancy Law',
  [LawFieldEnum.MIGRATIONSRECHT]: 'Migration Law',
  [LawFieldEnum.MUSIKRECHT]: 'Music Law',
  [LawFieldEnum.NOTARIAT]: 'Notary',
  [LawFieldEnum.PERSONENSCHÄDEN]: 'Personal Injury',
  [LawFieldEnum.SCHUFA]: 'Credit Bureau',
  [LawFieldEnum.SCHULRECHT]: 'School Law',
  [LawFieldEnum.SOCIAL_MEDIA_RECHT]: 'Social Media Law',
  [LawFieldEnum.SOZIALRECHT]: 'Social Law',
  [LawFieldEnum.STEUERBERATUNG]: 'Tax Consulting',
  [LawFieldEnum.STEUERRECHT]: 'Tax Law',
  [LawFieldEnum.STRAFRECHT]: 'Criminal Law',
  [LawFieldEnum.TESLA_WIDERRUF]: 'Tesla Revocation',
  [LawFieldEnum.TIERRECHT]: 'Animal Law',
  [LawFieldEnum.VERKEHRSRECHT]: 'Traffic Law',
  [LawFieldEnum.VERSICHERUNGSRECHT]: 'Insurance Law',
  [LawFieldEnum.VERWALTUNGSRECHT]: 'Administrative Law',
  [LawFieldEnum.WEGRECHT]: 'Right of Way',
  [LawFieldEnum.ZIVILRECHT]: 'Civil Law'
}
